import { Component } from 'react';
import PropTypes from 'prop-types';
import injectTapEventPlugin from 'react-tap-event-plugin';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AcquireWebTheme from './AcquireWebTheme';

injectTapEventPlugin(); // a dependency of MaterialUI

class AcquireWebComponent extends Component {

	getChildContext() {
		const colorProps = [
			'primary1Color', 'primary2Color', 'primary3Color',
			'accent1Color', 'accent2Color'
		];
		colorProps.forEach((colorProp) => {
			AcquireWebTheme.palette[colorProp] = this.getNavColor ? this.getNavColor() : AcquireWebTheme.palette[colorProp]
		});

		return {
			muiTheme: getMuiTheme(AcquireWebTheme)
		};
	}
}

AcquireWebComponent.childContextTypes = {
	muiTheme: PropTypes.object
};

export default AcquireWebComponent;



// WEBPACK FOOTER //
// ./src/components/framework/MaterialUI/index.js